import Analytics from '@components/charts/analytics/Analytics'
import AverageSessionDurationForUser from '@components/charts/user/AverageSessionDurationForUser'
import BookingFunnel from '@components/charts/user/BookingFunnel'
import VisitedVenues from '@components/charts/user/VisitedVenues'
import Page from '@components/Page/Page'
import { User } from '@components/user/User'
import { AnalyticsProvider } from '@contexts/AnalyticsContext'
import { useAppSelector } from '@store/hooks'
import { selectSelectedUser } from '@store/UserReducer'
import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import { Col, Row, Space, Spin, TimeRangePickerProps } from 'antd'
import dayjs, { Dayjs } from 'dayjs'

const rangePresets: TimeRangePickerProps['presets'] = [
  {
    label: 'Last 6 months',
    value: [dayjs().subtract(6, 'month'), dayjs().subtract(1, 'day')],
  },
  {
    label: 'Last 12 months',
    value: [dayjs().subtract(12, 'month'), dayjs().subtract(1, 'day')],
  },
  {
    label: 'This year',
    value: [dayjs().startOf('year'), dayjs().subtract(1, 'day')],
  },
  {
    label: 'Last year',
    value: [
      dayjs().subtract(1, 'year').startOf('year'),
      dayjs().subtract(1, 'year').endOf('year'),
    ],
  },
  {
    label: 'All time',
    value: [dayjs('01/01/1970'), dayjs().subtract(1, 'day')],
  },
]

const AnalyticsTabContent = () => {
  const user = useAppSelector(selectSelectedUser())

  if (!user) {
    return <Spin />
  }

  return (
    <Page rowGutter={[32, 32]} noWrapWithCol>
      <Col span={24}>
        <Space orientation="vertical" className="w-full" size={10}>
          <PageTitle
            level={5}
            title={'Analytics'}
            style={{ margin: 0 }}
            toolbar={
              <Analytics.Date
                rangePresets={rangePresets}
                defaultValue={rangePresets[1].value as [Dayjs, Dayjs]}
              />
            }
          />
          <Analytics.RowStatistics
            entity="user"
            entityId={user.id}
            kind="user-visit-spend"
          />
        </Space>
      </Col>

      <Col span={24}>
        <Row gutter={[32, 32]}>
          <Col sm={12} xs={24}>
            <Space orientation="vertical" className="w-full" size={10}>
              <PageTitle
                level={5}
                title={'Booking conversion'}
                style={{ margin: 0 }}
              />
              <BookingFunnel />
            </Space>
          </Col>
          <Col sm={12} xs={24}>
            <Space orientation="vertical" className="w-full" size={10}>
              <PageTitle
                level={5}
                title={'Visits & spends'}
                style={{ margin: 0 }}
              />
              <VisitedVenues />
            </Space>
          </Col>
          <Col sm={12} xs={24}>
            <Space orientation="vertical" className="w-full" size={10}>
              <PageTitle
                level={5}
                title={'Average session duration'}
                style={{ margin: 0 }}
              />
              <AverageSessionDurationForUser />
            </Space>
          </Col>
          <Col sm={12} xs={24}>
            <User.EventList userId={user.id} />
          </Col>
        </Row>
      </Col>
    </Page>
  )
}

const AnalyticsTab = () => {
  return (
    <AnalyticsProvider>
      <AnalyticsTabContent />
    </AnalyticsProvider>
  )
}

export default AnalyticsTab
